import React from 'react';
import cx from 'classnames';
import { defineMessages, IntlShape, useIntl } from 'react-intl';

import { formatDateLabel, formatDay, formatTimeRangeLabel } from 'volto-apanymantel/helpers';

const messages = defineMessages({
  
});

interface ObjectListWidgetProps {
  value: Record<string, any>;
  children: any;
  className: any;
}

const ObjectListWidget: React.FC<ObjectListWidgetProps> = ({ value, children, className }) => {
  //return value.toString();
  return value ? (
    <span className={cx(className, 'array', 'widget')}>
      {value.map((item, key) => (
        <React.Fragment key={item['@id']}>
          {key ? ', ' : ''}
          <span key={item['@id']}>
            {children
              ? children(item.title)
              : item.title}
            </span>
        </React.Fragment>
      ))}
    </span>
  ) : (
    ''
  );
}

export default ObjectListWidget;
